document.addEventListener('DOMContentLoaded', function () {

  // ---- Main menu toggle ----
  const btn = document.getElementById('mobile_menu');
  const nav = document.getElementById('top_nav');
  const iconHamburger = document.getElementById('icon_hamburger');
  const iconClose = document.getElementById('icon_close');

  btn.addEventListener('click', () => {
    nav.classList.toggle('hidden');

    // toggle icons
    iconHamburger.classList.toggle('hidden');
    iconClose.classList.toggle('hidden');
  });


  // ---- SUB_MENU ----
  document.querySelectorAll('.submenu_icon').forEach(subMenuButton => {
    subMenuButton.addEventListener('click', () => {
      const subMenu = subMenuButton.parentNode.nextElementSibling;
      if (subMenu) {
        if (subMenu.classList.contains('hidden')) {
          subMenu.classList.remove('hidden');
          setTimeout(() => {
            subMenu.classList.add('transition-all', 'duration-300');
            subMenu.classList.remove('opacity-0');
            subMenu.classList.add('opacity-100');
            subMenuButton.classList.add('rotate-180');
          }, 10);
        } else {
          subMenu.classList.add('opacity-0');
          subMenu.classList.remove('opacity-100');
          subMenu.classList.add('transition-all', 'duration-300');
          subMenuButton.classList.remove('rotate-180');
          setTimeout(() => {
            subMenu.classList.add('hidden');
          }, 300);
        }
      }
    });
  });

  // ---- SEARCH TOGGLE ----
  let searchButton = document.querySelector(".search-button");
  let searchContainer = document.querySelector(".search_container");
  
  searchButton.addEventListener("click", function () {
    let isHidden = searchContainer.classList.contains("opacity-0");

    if (isHidden) {
      searchContainer.classList.remove("opacity-0", "scale-95", "pointer-events-none");
      searchContainer.classList.add("opacity-100", "scale-100");
    } else {
      searchContainer.classList.remove("opacity-100", "scale-100");
      searchContainer.classList.add("opacity-0", "scale-95", "pointer-events-none");
    }
  });

  // ---- ATTACH SPLIDE ----
  if (document.getElementById('album_lists')) {
    new Splide('#album_lists', {
      type: 'slide',
      perPage: 4,
      pagination: false,
      gap: '1em',
      autoplay: true,
      interval: 5000,
      wheel: true, //
      flickMaxPages: 1,
      updateOnMove: true,
      direction: 'rtl',
      arrows: false,

      breakpoints: {
        768: {
          perPage: 1,
        },
        1024: {
          perPage: 2,
        },
      },
    }).mount();
  }
  // ---- ATTACH SPLIDE ----

  // ---- START OF light Gallery ----
  if (document.querySelectorAll('.album_list')) {
    var gallery = document.querySelectorAll(".album_list");
    gallery.forEach(function (pic) {
      lightGallery(pic, {
        speed: 500,
        plugins: [lgThumbnail],
        thumbnail: true,
        direction: 'ltr',
      });
    });
  }
  // ---- END OF light Gallery ----

  // ---- Responsive table ----
  if (document.querySelector(".ck_editor")) {
    var tables = document.querySelectorAll(".ck_editor table");
    tables.forEach(function (table) {
      var parentTable = document.createElement('div');
      parentTable.classList.add("table_res");
      table.parentNode.replaceChild(parentTable, table);
      parentTable.appendChild(table);
    });
  }

  // ---- SHORTLINK ----
  var shortLink = document.querySelector(".short_link");
  var copiedEl = document.querySelector(".tinyurl_copied");

  if (shortLink && copiedEl) {
  shortLink.addEventListener("click", function (e) {
    e.preventDefault();

    navigator.clipboard.writeText(shortLink.href);

    copiedEl.classList.toggle("hidden");
    copiedEl.classList.toggle("block");

    setTimeout(function () {
      copiedEl.classList.toggle("hidden");
      copiedEl.classList.toggle("block");
    }, 1500);
  });
  }
  // ---- END OF SHORTLINK ----

  // ---- START OF tiny url ----
  if (document.querySelector(".short_link2")) {
    var shortLink = document.querySelector(".short_link2");
    if (shortLink) {
      shortLink.addEventListener("click", function (event) {
        event.preventDefault();
        var temp = document.getElementById("short_link_copy");
        temp.select();
        document.execCommand("copy");
        document.querySelector(".copied").style.display = "block";
        setTimeout(function () {
          document.querySelector(".copied").style.display = "none";
        }, 1500);
      });
    }
  }
  // ---- END OF tiny url ----

  // ---- START OF COMMENT NEWS AJAX ----
  if (document.getElementById('comment_list_ajax')) {
    const commentList = document.getElementById('comment_list_ajax');
    const loadMoreBtn = document.getElementById('load_more_comment');
    let currentPage = 1;
    // Initialize limit comment number
    const limitPage = 5;

    if (news_comment < limitPage) loadMoreBtn.remove();

    const loadMoreComments = () => {
      fetch(`/comments/ajaxCommentList?newsId=${news_id}&page=${currentPage}&limit=${limitPage}`)
        .then(response => response.json())
        .then(data => {
          if (!data || data.length < limitPage) loadMoreBtn.style.display = 'none';
          if (data) {
            data.forEach(comment => {
              const renderChildren = children => children ? `<ul>${children.map(child => `
              <li>
                <div class="comment_list_header">
                  <div class="comment_list_user">${child.name || window.i18n.commentUnknown}</div>
                  <div class="comment_reply">
                    <span class="comment_published">
                      <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="16" height="16" preserveAspectRatio="xMidYMid meet" viewBox="0 0 1536 1536"><path fill="#1d1f27" d="M896 416v448q0 14-9 23t-23 9H544q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h224V416q0-14 9-23t23-9h64q14 0 23 9t9 23zm416 352q0-148-73-273t-198-198t-273-73t-273 73t-198 198t-73 273t73 273t198 198t273 73t273-73t198-198t73-273zm224 0q0 209-103 385.5T1153.5 1433T768 1536t-385.5-103T103 1153.5T0 768t103-385.5T382.5 103T768 0t385.5 103T1433 382.5T1536 768z"></path></svg>
                      <time datetime="${child.creation}">${child.date}</time>
                    </span>
                    <button aria-label="like" onclick="Rate.plus(${child.master_id})" class="like">
                      <span id="rateplus${child.master_id}">${child.plus || 0}</span>
                      <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" role="img" width="14" height="14" preserveAspectRatio="xMidYMid meet" viewBox="0 0 1024 1024"><path d="M885.9 533.7c16.8-22.2 26.1-49.4 26.1-77.7c0-44.9-25.1-87.4-65.5-111.1a67.67 67.67 0 0 0-34.3-9.3H572.4l6-122.9c1.4-29.7-9.1-57.9-29.5-79.4A106.62 106.62 0 0 0 471 99.9c-52 0-98 35-111.8 85.1l-85.9 311h-.3v428h472.3c9.2 0 18.2-1.8 26.5-5.4c47.6-20.3 78.3-66.8 78.3-118.4c0-12.6-1.8-25-5.4-37c16.8-22.2 26.1-49.4 26.1-77.7c0-12.6-1.8-25-5.4-37c16.8-22.2 26.1-49.4 26.1-77.7c-.2-12.6-2-25.1-5.6-37.1zM112 528v364c0 17.7 14.3 32 32 32h65V496h-65c-17.7 0-32 14.3-32 32z"/></svg>
                    </button>
                    <button aria-label="dislike" onclick="Rate.minus(${child.master_id})" class="dislike">
                      <span id="rateminus${child.master_id}">${child.minus || 0}</span>
                      <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" role="img" width="14" height="14" preserveAspectRatio="xMidYMid meet" viewBox="0 0 1024 1024"><path d="M885.9 490.3c3.6-12 5.4-24.4 5.4-37c0-28.3-9.3-55.5-26.1-77.7c3.6-12 5.4-24.4 5.4-37c0-28.3-9.3-55.5-26.1-77.7c3.6-12 5.4-24.4 5.4-37c0-51.6-30.7-98.1-78.3-118.4a66.1 66.1 0 0 0-26.5-5.4H273v428h.3l85.8 310.8C372.9 889 418.9 924 470.9 924c29.7 0 57.4-11.8 77.9-33.4c20.5-21.5 31-49.7 29.5-79.4l-6-122.9h239.9c12.1 0 23.9-3.2 34.3-9.3c40.4-23.5 65.5-66.1 65.5-111c0-28.3-9.3-55.5-26.1-77.7zM112 132v364c0 17.7 14.3 32 32 32h65V100h-65c-17.7 0-32 14.3-32 32z"/></svg>
                    </button>
                    <button aria-label="replay" onclick="setCommentParentId(${child.id})" class="reply">${window.i18n.commentReply}</button>
                  </div>
                </div>
                <div class="matn_comment">
                  <p>${child.message}</p>
                </div>
              </li>`).join('')}</ul>` : '';

              commentList.innerHTML += `
              <li>
                <div class="comment_list_header">
                  <div class="comment_list_user">${comment.name || window.i18n.commentUnknown}</div>
                  <div class="comment_reply">
                    <span class="comment_published">
                      <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="16" height="16" preserveAspectRatio="xMidYMid meet" viewBox="0 0 1536 1536"><path fill="#1d1f27" d="M896 416v448q0 14-9 23t-23 9H544q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h224V416q0-14 9-23t23-9h64q14 0 23 9t9 23zm416 352q0-148-73-273t-198-198t-273-73t-273 73t-198 198t-73 273t73 273t198 198t273 73t273-73t198-198t73-273zm224 0q0 209-103 385.5T1153.5 1433T768 1536t-385.5-103T103 1153.5T0 768t103-385.5T382.5 103T768 0t385.5 103T1433 382.5T1536 768z"></path></svg>
                      <time datetime="${comment.creation}">${comment.date}</time>
                    </span>
                    <button aria-label="like" onclick="Rate.plus(${comment.master_id})" class="like">
                      <span id="rateplus${comment.master_id}">${comment.plus || 0}</span>
                      <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" role="img" width="14" height="14" preserveAspectRatio="xMidYMid meet" viewBox="0 0 1024 1024"><path d="M885.9 533.7c16.8-22.2 26.1-49.4 26.1-77.7c0-44.9-25.1-87.4-65.5-111.1a67.67 67.67 0 0 0-34.3-9.3H572.4l6-122.9c1.4-29.7-9.1-57.9-29.5-79.4A106.62 106.62 0 0 0 471 99.9c-52 0-98 35-111.8 85.1l-85.9 311h-.3v428h472.3c9.2 0 18.2-1.8 26.5-5.4c47.6-20.3 78.3-66.8 78.3-118.4c0-12.6-1.8-25-5.4-37c16.8-22.2 26.1-49.4 26.1-77.7c0-12.6-1.8-25-5.4-37c16.8-22.2 26.1-49.4 26.1-77.7c-.2-12.6-2-25.1-5.6-37.1zM112 528v364c0 17.7 14.3 32 32 32h65V496h-65c-17.7 0-32 14.3-32 32z"/></svg>
                    </button>
                    <button aria-label="dislike" onclick="Rate.minus(${comment.master_id})" class="dislike">
                      <span id="rateminus${comment.master_id}">${comment.minus || 0}</span>
                      <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" role="img" width="14" height="14" preserveAspectRatio="xMidYMid meet" viewBox="0 0 1024 1024"><path d="M885.9 490.3c3.6-12 5.4-24.4 5.4-37c0-28.3-9.3-55.5-26.1-77.7c3.6-12 5.4-24.4 5.4-37c0-28.3-9.3-55.5-26.1-77.7c3.6-12 5.4-24.4 5.4-37c0-51.6-30.7-98.1-78.3-118.4a66.1 66.1 0 0 0-26.5-5.4H273v428h.3l85.8 310.8C372.9 889 418.9 924 470.9 924c29.7 0 57.4-11.8 77.9-33.4c20.5-21.5 31-49.7 29.5-79.4l-6-122.9h239.9c12.1 0 23.9-3.2 34.3-9.3c40.4-23.5 65.5-66.1 65.5-111c0-28.3-9.3-55.5-26.1-77.7zM112 132v364c0 17.7 14.3 32 32 32h65V100h-65c-17.7 0-32 14.3-32 32z"/></svg>
                    </button>
                    <button aria-label="replay" onclick="setCommentParentId(${comment.id})" class="reply">${window.i18n.commentReply}</button>
                  </div>
                </div>
                <div class="matn_comment">
                  <p>${comment.message}</p>
                  ${comment.children === null || comment.children.length === 0 ? '' : renderChildren(comment.children)}
                </div>
              </li>`;
            });
            currentPage++;
          }
        })
        .catch(error => console.error(error));
    };

    loadMoreComments();
    loadMoreBtn.addEventListener('click', loadMoreComments);
  }

  // ---- END OF COMMENT NEWS AJAX ----


})
